// extracted by mini-css-extract-plugin
module.exports = {"container":"MobileNavigation_container__R7yO_","menuIsOpen":"MobileNavigation_menuIsOpen__MwabK"};